export default __webpack_public_path__ + "static/media/pending.71e5712d.svg";